/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Support_Platformquestions_Title1Inputs */

const en_settings_support_platformquestions_title1 = /** @type {(inputs: Settings_Support_Platformquestions_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vega Platform Questions`)
};

/**
* | output |
* | --- |
* | "Vega Platform Questions" |
*
* @param {Settings_Support_Platformquestions_Title1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_support_platformquestions_title1 = /** @type {((inputs?: Settings_Support_Platformquestions_Title1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Support_Platformquestions_Title1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_support_platformquestions_title1(inputs)
});
export { settings_support_platformquestions_title1 as "settings_support_platformQuestions_title" }